
import { Component, Mixins, Ref } from 'vue-property-decorator'
import NotificationDialog from './NotificationDialog.vue'
import { handlerClick } from './notify-handler'
import { SysNotifyListOutput as Notification } from '@/api/swagger'
import PaginationMixin from '@/mixins/pagination-mixin'
import { useNotifyStore } from '@/store/notify'

@Component({
  components: {
    NotificationDialog,
  },
})
export default class extends Mixins(PaginationMixin) {
  @Ref('NotificationDialog')
  private refNotificationDialog!: NotificationDialog

  private notifyStore = useNotifyStore()

  private loading = false

  private dataSource: Notification[] = []

  private ws: WebSocket | null = null

  private async handler(notify: Notification) {
    await this.$http.post('/api/Notify/Readed', { ids: [notify.id as string] })
    notify.readed = true
    this.notifyStore.updateUnreadCount()
    const { redirect } = await handlerClick(notify)

    if (redirect) {
      await this.$router.push(redirect)
    }
  }

  private onChange() {
    this.load()
    // this.notifyStore.updateUnreadCount();
  }

  private async load() {
    this.loading = true

    const res = await this.$http.get('/api/Notify/PageLite', {
      Page: this.pagination.query.page as number,
      PageSize: 5,
    })

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.dataSource = res.data.list!
    this.pagination.update(res.data)

    this.loading = false
  }

  // 打开全部消息
  private openAll() {
    this.refNotificationDialog.open()
  }

  protected created() {
    this.pagination.updateDefaults({
      current: this.pagination.defaults.current,
      pageSize: 5,
    })
    // this.load();
    this.connect()
  }

  protected mounted() {
    this.notifyStore.updateUnreadCount()
  }

  protected destroyed() {
    this.ws?.close()
  }

  private connect() {
    this.$http.get('/api/Websocket/PreConnect', {}).then((res) => {
      const { data } = res
      if (data.server) {
        this.ws = new WebSocket(data.server)

        this.ws.addEventListener('message', (e) => {
          const responseData = JSON.parse(e.data)

          if (responseData && responseData.Type === 'MsgUnreadCount') {
            if (responseData.Payload) {
              this.notifyStore.UPDATE_UNREAD_COUNT(responseData.Payload?.Count)
              this.$notification.open({
                message: responseData.Payload?.Title,
                description: responseData.Payload?.Msg,
                top: '80px',
              })
            }
          }
        })

        this.notifyStore.UPDATE_WEBSOCKET_ID(data?.websocketId)
      }
    })
  }
}
